import { useState } from "react";

export default function SidebarFilter({
  onFilter,
  dataLookupUsers,
  activeFilterMo,
  lookupCategory,
  lookupSubCategory,
  lookupTypeProduct,
  subCategoryDisable,
  productTypeDisable,
  onCategoryChange,
  onSubCategoryChange,
  getSubCategoryLoading,
  getProductTypeLoading
}) {
  const [errors, setErrors] = useState({});

  const handleSubmitFilter = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const filterObj = Object.fromEntries(formData.entries());
    const newErrors = {};

    const tanggal_dari = filterObj.tanggal_dari;
    const tanggal_sampai = filterObj.tanggal_sampai;
    const contract_value_from = filterObj.contract_value_from;
    const contract_value_to = filterObj.contract_value_to;

    Object.keys(filterObj).forEach((key) => {
      if (filterObj[key] === "") {
        delete filterObj[key];
      }
    });

    if (tanggal_dari && tanggal_sampai && tanggal_dari > tanggal_sampai) {
      newErrors.tanggal_sampai =
        "Tanggal Sampai tidak boleh lebih awal dari Tanggal Dari";
    }
    if (
      contract_value_from &&
      contract_value_to &&
      contract_value_from > contract_value_to
    ) {
      newErrors.contract_value_to =
        "Nominal Sampai tidak boleh lebih awal dari Nominal Dari";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const finalFilter = { ...filterObj, moId: activeFilterMo };

    onFilter(finalFilter);
    document.querySelector("#filterSidebar .btn-close")?.click();
  };

  return (
    <div>
      {/* Trigger button */}
      <button
        className="btn btn-primary shadow-sm px-4"
        data-bs-toggle="offcanvas"
        data-bs-target="#filterSidebar"
      >
        <i className="fa fa-filter me-2"></i> Filter
      </button>

      {/* Sidebar */}
      <div
        className="offcanvas offcanvas-end w-50 w-md-50 w-lg-30"
        id="filterSidebar"
      >
        <div className="offcanvas-header border-bottom bg-light sticky-top">
          <h5 className="offcanvas-title fw-bold text-primary">
            <i className="fa fa-sliders me-2"></i> Filter Leads
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        <div className="offcanvas-body bg-light">
          <form
            onSubmit={handleSubmitFilter}
            className="d-flex flex-column gap-4"
          >
            {/* Tim Penanggung Jawab */}
            <div className="card shadow-sm border-0 rounded-4">
              <div className="card-header bg-white fw-semibold">
                <i className="fa fa-users me-2 text-primary"></i> Tim Penanggung
                Jawab
              </div>
              <div className="card-body row g-3">
                <div className="col-md-6">
                  <label className="form-label">TLS</label>
                  <select name="tls" className="form-select shadow-sm">
                    <option value="">-- Pilih TLS --</option>
                    {dataLookupUsers.tls?.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Sales</label>
                  <select name="sales" className="form-select shadow-sm">
                    <option value="">-- Pilih Sales --</option>
                    {dataLookupUsers.sales?.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Rentang Tanggal */}
            <div className="card shadow-sm border-0 rounded-4">
              <div className="card-header bg-white fw-semibold">
                <i className="fa-regular fa-calendar-days me-2 text-success"></i>{" "}
                Rentang Tanggal
              </div>
              <div className="card-body row g-3">
                <div className="col-md-6">
                  <label className="form-label">Tanggal Dari</label>
                  <input
                    type="date"
                    className={`form-control shadow-sm ${
                      errors.tanggal_dari ? "is-invalid" : ""
                    }`}
                    name="tanggal_dari"
                  />
                  <div className="invalid-feedback">
                    {errors.tanggal_dari || ""}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Tanggal Sampai</label>
                  <input
                    type="date"
                    className={`form-control shadow-sm ${
                      errors.tanggal_sampai ? "is-invalid" : ""
                    }`}
                    name="tanggal_sampai"
                  />
                  <div className="invalid-feedback">
                    {errors.tanggal_sampai || ""}
                  </div>
                </div>
              </div>
            </div>

            {/* Detail Kontak */}
            <div className="card shadow-sm border-0 rounded-4">
              <div className="card-header bg-white fw-semibold">
                <i className="fa fa-id-card me-2 text-info"></i> Detail Kontak
              </div>
              <div className="card-body row g-3">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    name="name"
                    placeholder="Nama"
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="email"
                    className="form-control shadow-sm"
                    name="email"
                    placeholder="Email"
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    name="phone_number"
                    placeholder="No HP / Telp"
                  />
                </div>
              </div>
            </div>

            {/* Detail Barang */}
            <div className="card shadow-sm border-0 rounded-4">
              <div className="card-header bg-white fw-semibold">
                <i className="fa fa-box-open me-2 text-warning"></i> Detail
                Barang
              </div>
              <div className="card-body row g-3">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    name="organization"
                    placeholder="Instansi/Business"
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    name="product_needs"
                    placeholder="Kebutuhan Product"
                  />
                </div>
                <hr />
                <div className="col-md-6">
                  <select
                    name="product_category"
                    onChange={(e) => onCategoryChange(e)}
                    className="form-select"
                  >
                    <option value="">Pilih Kategori</option>
                    {lookupCategory.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 position-relative">
                  <select
                    name="product_subcategory"
                    onChange={onSubCategoryChange}
                    className="form-select"
                    disabled={subCategoryDisable}
                  >
                    <option value="">Pilih Subkategori</option>
                    {lookupSubCategory.map((sub) => (
                      <option key={sub.id} value={sub.id}>
                        {sub.name}
                      </option>
                    ))}
                  </select>

                  {getSubCategoryLoading && (
                    <div
                      className="position-absolute top-50 end-50 translate-middle-y me-3"
                      style={{ pointerEvents: "none" }}
                    >
                      <div
                        className="spinner-border spinner-border-sm text-secondary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-6 position-relative">
                  <select
                    name="product_type"
                    // onChange={(e) => onSubCategoryChange(e)}
                    className="form-select"
                    disabled={productTypeDisable}
                  >
                    <option value="">Pilih Tipe Kategori</option>
                    {lookupTypeProduct.map((sub) => (
                      <option key={sub.id} value={sub.id}>
                        {sub.name}
                      </option>
                    ))}
                  </select>
                  {getProductTypeLoading && (
                    <div
                      className="position-absolute top-50 end-50 translate-middle-y me-3"
                      style={{ pointerEvents: "none" }}
                    >
                      <div
                        className="spinner-border spinner-border-sm text-secondary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>
                <hr />
                <div className="col-md-6">
                  <select
                    name="organization_type"
                    className="form-select shadow-sm"
                  >
                    <option value="">-- Pilih Pemerintah/Swasta --</option>
                    <option value="pemerintah">Pemerintah</option>
                    <option value="swasta">Swasta</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <select name="lead_source" className="form-select shadow-sm">
                    <option value="">-- Pilih Sumber --</option>
                    <option value="Google Ads">Google Ads</option>
                    <option value="SEO">SEO</option>
                    <option value="Meta Ads">Meta Ads</option>
                    <option value="Woowa Marketing">Woowa Marketing</option>
                    <option value="Email">Email</option>
                    <option value="Social Media">Social Media</option>
                    <option value="Chat Inaproc">Chat Inaproc</option>
                    <option value="Telephone Kantor">Telephone Kantor</option>
                    <option value="WA, Telp By Direktur">
                      WA, Telp By Direktur
                    </option>
                    <option value="Broker/Relasi">Broker/Relasi</option>
                    <option value="Repeat Order">Repeat Order</option>
                    <option value="Inaproc/E-katalog">Inaproc/E-katalog</option>
                    <option value="Website">Website</option>
                    <option value="Minkom">Minkom</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <select name="company" className="form-select shadow-sm">
                    <option value="">-- Pilih Perusahaan --</option>
                    <option value="SK">SK</option>
                    <option value="BCS">BCS</option>
                    <option value="MBA">MBA</option>
                    <option value="DHA">DHA</option>
                    <option value="ITG">ITG</option>
                    <option value="KNP">KNP</option>
                    <option value="KPK">KPK</option>
                    <option value="TSI">TSI</option>
                    <option value="SAR">SAR</option>
                    <option value="SK. Suroboyo Mandiri">
                      SK. Suroboyo Mandiri
                    </option>
                    <option value="SKTP">SKTP</option>
                    <option value="SKAP">SKAP</option>
                    <option value="SKSM">SKSM</option>
                    <option value="SKMJ">SKMJ</option>
                    <option value="SKCI">SKCI</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <select name="lead_status" className="form-select shadow-sm">
                    <option value="">-- Pilih Status Leads --</option>
                    <option value="Cold" className="text-primary fw-bold">
                      Cold
                    </option>
                    <option value="Warm" className="text-warning fw-bold">
                      Warm
                    </option>
                    <option value="Hot" className="text-danger fw-bold">
                      Hot
                    </option>
                  </select>
                </div>
                <div className="col-md-6">
                  <select name="spk_status" className="form-select shadow-sm">
                    <option value="">-- Pilih Proses --</option>
                    <option value="SPK">SPK</option>
                    <option value="On Progress">On Progress</option>
                    <option value="Tidak SPK">Tidak SPK</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <select
                    name="response_status"
                    className="form-select shadow-sm"
                  >
                    <option value="">-- Pilih Respon --</option>
                    <option value="Respon">Respon</option>
                    <option value="Tidak Respon">Tidak Respon</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Keuangan */}
            <div className="card shadow-sm border-0 rounded-4">
              <div className="card-header bg-white fw-semibold">
                <i className="fa fa-coins me-2 text-success"></i> Nominal
              </div>
              <div className="card-body">
                {/* Pagu */}
                {/* <label className="form-label fw-semibold">Nominal Pagu</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">Rp</span>
                  <input type="number" name="budget_from" className="form-control shadow-sm" placeholder="Dari" />
                  <span className="input-group-text">s/d</span>
                  <input type="number" name="budget_to" className="form-control shadow-sm" placeholder="Sampai" />
                </div> */}

                {/* RAB */}
                {/* <label className="form-label fw-semibold">Nominal RAB</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">Rp</span>
                  <input type="number" name="estimated_budget_from" className="form-control shadow-sm" placeholder="Dari" />
                  <span className="input-group-text">s/d</span>
                  <input type="number" name="estimated_budget_to" className="form-control shadow-sm" placeholder="Sampai" />
                </div> */}

                {/* SPK */}
                <label className="form-label fw-semibold">Nominal SPK</label>
                <div className="input-group">
                  <span className="input-group-text">Rp</span>
                  <input
                    type="number"
                    name="contract_value_from"
                    className={`form-control shadow-sm ${
                      errors.contract_value_from ? "is-invalid" : ""
                    }`}
                    placeholder="Dari"
                  />
                  <div className="invalid-feedback">
                    {errors.contract_value_from || ""}
                  </div>
                  <span className="input-group-text">s/d</span>
                  <input
                    type="number"
                    name="contract_value_to"
                    className={`form-control shadow-sm ${
                      errors.contract_value_to ? "is-invalid" : ""
                    }`}
                    placeholder="Sampai"
                  />
                  <div className="invalid-feedback">
                    {errors.contract_value_to || ""}
                  </div>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="d-flex gap-2">
              <button
                type="reset"
                className="btn btn-outline-secondary w-50 rounded-pill shadow-sm"
              >
                <i className="fa fa-undo me-2"></i> Reset
              </button>
              <button
                type="submit"
                className="btn btn-gradient-primary w-50 rounded-pill shadow-sm"
              >
                <i className="fa fa-check me-2"></i> Terapkan
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
